import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type FundraisingIconProps = IconProps;

const FundraisingIcon: FC<FundraisingIconProps> = ({ className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_14577_89733)">
      <path
        d="M14.6663 4.66699L9.42059 9.91275C9.15658 10.1768 9.02457 10.3088 8.87235 10.3582C8.73846 10.4017 8.59423 10.4017 8.46033 10.3582C8.30811 10.3088 8.17611 10.1768 7.91209 9.91274L6.08725 8.08791C5.82324 7.82389 5.69124 7.69189 5.53902 7.64243C5.40512 7.59893 5.26089 7.59893 5.127 7.64243C4.97478 7.69189 4.84277 7.82389 4.57876 8.08791L1.33301 11.3337M14.6663 4.66699H9.99967M14.6663 4.66699V9.33366"
        stroke="url(#paint0_linear_14577_89733)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="8.4"
        id="filter0_i_14577_89733"
        width="14.667"
        x="0.666016"
        y="4"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="0.4" />
        <feGaussianBlur stdDeviation="0.2" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend in2="shape" mode="normal" result="effect1_innerShadow_14577_89733" />
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_14577_89733"
        x1="1.05523"
        x2="6.35561"
        y1="6.47255"
        y2="17.1837"
      >
        <stop stopColor="#12B76A" />
        <stop offset="1" stopColor="#05603A" />
      </linearGradient>
    </defs>
  </svg>
);

export default FundraisingIcon;
